var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7012 25.4323C16.8712 23.5587 23.3334 17.492 23.3334 11.6668C23.3334 9.19148 22.3501 6.81751 20.5997 5.06717C18.8494 3.31683 16.4754 2.3335 14.0001 2.3335C11.5247 2.3335 9.15076 3.31683 7.40042 5.06717C5.65008 6.81751 4.66675 9.19148 4.66675 11.6668C4.66675 17.492 11.1289 23.5587 13.2989 25.4323C13.5011 25.5843 13.7472 25.6665 14.0001 25.6665C14.253 25.6665 14.4991 25.5843 14.7012 25.4323Z",
    stroke: "#0F4A43",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1665C15.933 15.1665 17.5 13.5995 17.5 11.6665C17.5 9.73351 15.933 8.1665 14 8.1665C12.067 8.1665 10.5 9.73351 10.5 11.6665C10.5 13.5995 12.067 15.1665 14 15.1665Z",
    stroke: "#0F4A43",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.eccd8e9b.svg";
export { ForwardRef as ReactComponent };